import React, { Suspense } from 'react';

import pluralize from 'helpers/pluralize';

import Message from 'components/base/Message/Message';
import Layout from 'components/styled/Layout/Layout';
import BrowseEntitiesSkeleton from 'components/data-containers/BrowseEntities/SkeletonLoader';
import PerformanceBreakdownLoader from 'components/data-containers/PerformanceBreakdown/SkeletonLoader';
import { EntityContext } from 'context/entityContext';

const BrowseEntity = React.lazy(
  () => import('components/data-containers/BrowseEntities/BrowseEntity')
);

const PerformanceBreakdown = React.lazy(
  () =>
    import(
      'components/data-containers/ShortFormVideoTotalToDate/PerformanceBreakdown'
    )
);

const ShortFormVideo: React.FC = () => {
  const ctx = React.useContext(EntityContext);
  const { compareMode, entityType } = ctx;

  // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
  return (
    <div>
      {!compareMode && (
        <React.Suspense
          fallback={
            <BrowseEntitiesSkeleton
              title="Browse Tracks"
              browseEntityType="track"
              enableSearch
            />
          }
        >
          <BrowseEntity {...ctx} id="browse-tracks" browseEntityType="track" />
        </React.Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message>
            Short Form Video is not available in compare mode. Exit compare mode
            to see Short Form Video data for this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}

      <Layout.MaxWidth>
        <Message>
          Short Form Video is not available for releases. Select a track to see
          related Short Form Video data.
        </Message>
      </Layout.MaxWidth>

      {!compareMode && (
        <Suspense
          fallback={
            <PerformanceBreakdownLoader
              barCount={2}
              title="Short Form Video Total To Date"
            />
          }
        >
          <PerformanceBreakdown />
        </Suspense>
      )}

      {compareMode && (
        <Layout.MaxWidth>
          <Message>
            Short Form Video Total to Date is not available in compare{' '}
            {pluralize(compareMode === 'country' ? compareMode : entityType)}{' '}
            mode. Exit compare mode to see Short Form Video Total to Date for
            this {entityType}.
          </Message>
        </Layout.MaxWidth>
      )}
    </div>
  );
};

export default ShortFormVideo;
